import { render, staticRenderFns } from "./FormProjects.vue?vue&type=template&id=33316254&"
import script from "./FormProjects.vue?vue&type=script&lang=js&"
export * from "./FormProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports